import * as T from 'three';

/** Preview models own their texture instances, even when their pixel data is cached. */
export function disposePreviewModel(scene:T.Object3D){
 const geometries=new Set<T.BufferGeometry>(),materials=new Set<T.Material>(),textures=new Set<T.Texture>();
 scene.traverse(object=>{
  if(object instanceof T.Mesh||object instanceof T.Line){
   geometries.add(object.geometry);
   for(const material of Array.isArray(object.material)?object.material:[object.material])materials.add(material);
  }
  if(object instanceof T.Light&&'shadow' in object)(object as T.DirectionalLight).shadow?.dispose();
 });
 for(const material of materials)for(const value of Object.values(material))if(value instanceof T.Texture)textures.add(value);
 // Materials may have their own texture cleanup listeners; duplicate dispose events are harmless.
 for(const texture of textures)texture.dispose();
 for(const material of materials)material.dispose();
 for(const geometry of geometries)geometry.dispose();
}
